import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';



import Swiper from "swiper";
export default class VideosSnap{ 
    
    constructor(element) {
        this._wrapper = element;
        this._swiperEl = this._wrapper.querySelector('.swiper');
        this._triggers = document.querySelectorAll('.js-videos-snap-trigger');
        this.players = this._wrapper.querySelectorAll('media-player');
        this._back = this._wrapper.querySelector('.js-videos-snap-back');
        this._cookiesAccept = this._wrapper.querySelectorAll('.js-cookies-consent-youtube');
        
        this.swiper = new Swiper(this._swiperEl, {
            direction:'vertical'
        })
        this.currentIndex = 0;
        this.isMoving = false;
        
        this.swiper.on('slideChange', () => {
            app.nodesEach(this.players, (el) => {
               el.pause(); 
            });
            this.playUntilSuccess(this.players[this.swiper.realIndex]);
        });
        
        this._swiperEl.addEventListener('touchstart', () => {
            // this.unMute();
        })
        
        this.bindEvents();
    }
    
    unMute(){
        app.nodesEach(this.players, (el) => {
            el.muted = false;
        })
    }

    playUntilSuccess(player) {
        // player.muted = false;
        player.play().catch((e) => {
            console.error(`Error playing: ${e.message}`);
            setTimeout(() => this.playUntilSuccess(player), 100);
        });
    }
    bindEvents(){
        app.nodesEventListener('click', this._triggers, (el) => {
            if(this.isMobile()){
                
                let id = parseInt(el.getAttribute('data-snap-id') - 1);
                this._wrapper.classList.add('is-open');
                if(id === 0){
                    this.players[0].play();
                }
                else{
                    this.swiper.slideTo(id);
                }
                disableBodyScroll(this._wrapper);
                this.unMute();
                
            }
        });
        this._back.addEventListener('click', () => {
            app.nodesEach(this.players, (el) => {
                el.pause();
            });
            clearAllBodyScrollLocks();
            this._wrapper.classList.remove('is-open');
        });
        if(this._cookiesAccept.length){
            app.nodesEventListener('click', this._cookiesAccept, () => {
                window.location.reload();
            })
        }
    }
    

    isMobile(){
        return window.matchMedia('(max-width:576px)').matches;
    }
    
} 
